import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";
import { mappingResultError, Result } from '@digibricks/core';
import { QUESTION_REPOSITORY, QuestionType } from '../../core';
import { ESSAY_QUESTION_API, FILL_IN_BLANK_QUESTION_API, MATCHING_QUESTION_API, MULTIPLE_CHOICE_QUESTION_API, QUESTION_API, SINGLE_CHOICE_QUESTION_API, SPEAKING_QUESTION_API } from '../../data';
export var QuestionWebRepository = /*#__PURE__*/function () {
  function QuestionWebRepository(questionApi, singleChoiceApi, multipleChoiceApi, fillInBlankApi, essayQuestionApi, matchingQuestionApi, speakingQuestionApi) {
    _classCallCheck(this, QuestionWebRepository);

    this.questionApi = questionApi;
    this.singleChoiceApi = singleChoiceApi;
    this.multipleChoiceApi = multipleChoiceApi;
    this.fillInBlankApi = fillInBlankApi;
    this.essayQuestionApi = essayQuestionApi;
    this.matchingQuestionApi = matchingQuestionApi;
    this.speakingQuestionApi = speakingQuestionApi;
  }

  _createClass(QuestionWebRepository, [{
    key: "findMany",
    value: function () {
      var _findMany = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(query) {
        var responseOrError;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.questionApi.findQuestions(query);

              case 2:
                responseOrError = _context.sent;
                return _context.abrupt("return", responseOrError);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function findMany(_x) {
        return _findMany.apply(this, arguments);
      }

      return findMany;
    }()
  }, {
    key: "findGroupedQuestionsBySection",
    value: function () {
      var _findGroupedQuestionsBySection = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(query) {
        var responseOrError;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.questionApi.findGroupedQuestionsBySection(query);

              case 2:
                responseOrError = _context2.sent;
                return _context2.abrupt("return", responseOrError);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function findGroupedQuestionsBySection(_x2) {
        return _findGroupedQuestionsBySection.apply(this, arguments);
      }

      return findGroupedQuestionsBySection;
    }()
  }, {
    key: "create",
    value: function () {
      var _create = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(question) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.t0 = question.type;
                _context3.next = _context3.t0 === QuestionType.Essay ? 3 : _context3.t0 === QuestionType.Speaking ? 4 : _context3.t0 === QuestionType.SingleChoice ? 5 : _context3.t0 === QuestionType.MultipleChoice ? 6 : _context3.t0 === QuestionType.FillInBlank ? 7 : _context3.t0 === QuestionType.Matching ? 8 : 9;
                break;

              case 3:
                return _context3.abrupt("return", this.essayQuestionApi.create(question));

              case 4:
                return _context3.abrupt("return", this.speakingQuestionApi.create(question));

              case 5:
                return _context3.abrupt("return", this.singleChoiceApi.create(question));

              case 6:
                return _context3.abrupt("return", this.multipleChoiceApi.create(question));

              case 7:
                return _context3.abrupt("return", this.fillInBlankApi.create(question));

              case 8:
                return _context3.abrupt("return", this.matchingQuestionApi.create(question));

              case 9:
                return _context3.abrupt("return", this.essayQuestionApi.create(question));

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function create(_x3) {
        return _create.apply(this, arguments);
      }

      return create;
    }()
  }, {
    key: "update",
    value: function () {
      var _update = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(question) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.t0 = question.type;
                _context4.next = _context4.t0 === QuestionType.Essay ? 3 : _context4.t0 === QuestionType.Speaking ? 4 : _context4.t0 === QuestionType.SingleChoice ? 5 : _context4.t0 === QuestionType.MultipleChoice ? 6 : _context4.t0 === QuestionType.FillInBlank ? 7 : _context4.t0 === QuestionType.Matching ? 8 : 9;
                break;

              case 3:
                return _context4.abrupt("return", this.essayQuestionApi.update(question));

              case 4:
                return _context4.abrupt("return", this.speakingQuestionApi.update(question));

              case 5:
                return _context4.abrupt("return", this.singleChoiceApi.update(question));

              case 6:
                return _context4.abrupt("return", this.multipleChoiceApi.update(question));

              case 7:
                return _context4.abrupt("return", this.fillInBlankApi.update(question));

              case 8:
                return _context4.abrupt("return", this.matchingQuestionApi.update(question));

              case 9:
                return _context4.abrupt("return", this.essayQuestionApi.update(question));

              case 10:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function update(_x4) {
        return _update.apply(this, arguments);
      }

      return update;
    }()
  }, {
    key: "delete",
    value: function () {
      var _delete2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(id) {
        var responseOrError;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.questionApi["delete"](id);

              case 2:
                responseOrError = _context5.sent;

                if (!responseOrError.isFailure) {
                  _context5.next = 5;
                  break;
                }

                return _context5.abrupt("return", mappingResultError(responseOrError));

              case 5:
                return _context5.abrupt("return", Result.ok(responseOrError.getValue()));

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function _delete(_x5) {
        return _delete2.apply(this, arguments);
      }

      return _delete;
    }()
  }, {
    key: "move",
    value: function () {
      var _move = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(id, dto) {
        var responseOrError;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.questionApi.move(id, dto);

              case 2:
                responseOrError = _context6.sent;

                if (!responseOrError.isFailure) {
                  _context6.next = 5;
                  break;
                }

                return _context6.abrupt("return", mappingResultError(responseOrError));

              case 5:
                return _context6.abrupt("return", Result.ok(responseOrError.getValue()));

              case 6:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function move(_x6, _x7) {
        return _move.apply(this, arguments);
      }

      return move;
    }()
  }]);

  return QuestionWebRepository;
}();
export var questionWebRepositoryProvider = {
  provide: QUESTION_REPOSITORY,
  useFactory: function useFactory(questionApi, singleChoiceApi, multipleChoiceApi, fillInBlankQuestionApi, essayQuestionApi, matchingQuestionApi, speakingQuestionApi) {
    return new QuestionWebRepository(questionApi, singleChoiceApi, multipleChoiceApi, fillInBlankQuestionApi, essayQuestionApi, matchingQuestionApi, speakingQuestionApi);
  },
  inject: [QUESTION_API, SINGLE_CHOICE_QUESTION_API, MULTIPLE_CHOICE_QUESTION_API, FILL_IN_BLANK_QUESTION_API, ESSAY_QUESTION_API, MATCHING_QUESTION_API, SPEAKING_QUESTION_API]
};